import * as React from 'react';
import { Formik, Form, FormikBag, FormikProps } from 'formik';
import {
  AnalyticsLoadingButton as LoadingButton,
  Button,
  AnalyticsPageView,
} from 'src/components/Analytics';
import { FormattedMessage } from 'react-intl';
import { personalIdNumberValidation } from './additionalStripeDetailsValidator';
import Alert from 'src/components/Alert';
import MaskedInput from 'react-text-mask';

export interface PersonalIdNumberData {
  personalIdNumber: string;
}

interface Props {
  updateStripeAccountDetails: (values: PersonalIdNumberData) => void;
  onSubmit: () => void;
}

class PersonalIdNumberForm extends React.Component<Props> {
  handleSubmit = async (
    values: PersonalIdNumberData,
    formikBag: FormikBag<Props, PersonalIdNumberData>
  ) => {
    try {
      formikBag.setStatus(null);
      await this.props.updateStripeAccountDetails(values);
      this.props.onSubmit();
    } catch (error) {
      formikBag.setSubmitting(false);
      formikBag.setStatus(error);
    }
  };

  render() {
    return (
      <AnalyticsPageView
        eventValue="verify identity - full ssn"
        pageSection="admin > verify identity"
        subtype="admin"
      >
        <div className="container jg-space-phsm jg-space-ptsm jg-space-phxxl@md">
          <Formik
            initialValues={{
              personalIdNumber: '',
            }}
            onSubmit={this.handleSubmit}
            validate={personalIdNumberValidation}
            validateOnChange
          >
            {({
              handleChange,
              handleBlur,
              values,
              errors,
              isSubmitting,
              isValid,
              setFieldValue,
              touched,
              setFieldTouched,
              status,
            }: FormikProps<PersonalIdNumberData>) => {
              return (
                <Form>
                  <div className="jg-text--center jg-space-mbmd">
                    <p className="jg-text--large">
                      <b>
                        <FormattedMessage
                          id="PersonalIdNumberForm.pleaseProvideText"
                          defaultMessage={`Please provide your Social Security Number (SSN)`}
                        />
                      </b>
                    </p>
                    <p>
                      <FormattedMessage
                        id="PersonalIdNumberForm.ssnMustMatchText"
                        defaultMessage={`The SSN must match the name and address you previously entered`}
                      />
                    </p>
                  </div>
                  <div className="jg-space-phlg@md">
                    <div className="jg-form-group">
                      <label
                        className="jg-form-label"
                        htmlFor="personalIdNumber"
                      >
                        <FormattedMessage
                          id="PersonalIdNumberForm.ssnFieldLabel"
                          defaultMessage={`Your Social Security Number`}
                        />
                      </label>
                      <MaskedInput
                        className={`jg-form-control ${
                          touched.personalIdNumber && errors.personalIdNumber
                            ? 'jg-form-control--error'
                            : ''
                        }`}
                        type="text"
                        id="personalIdNumber"
                        name="personalIdNumber"
                        placeholder="xxx-xx-xxxx"
                        placeholderChar={'\u2000'}
                        mask={[
                          /\d/,
                          /\d/,
                          /\d/,
                          '-',
                          /\d/,
                          /\d/,
                          '-',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.personalIdNumber}
                        onFocus={() => {
                          setFieldTouched('personalIdNumber');
                        }}
                      />
                      {touched.personalIdNumber &&
                        errors.personalIdNumber && (
                          <span
                            className="jg-form-error-copy jg-text--small"
                            role="alert"
                          >
                            {errors.personalIdNumber}
                          </span>
                        )}
                    </div>
                    <div>
                      {status && (
                        <div className="jg-space-mtsm jg-space-mbmd">
                          <Alert
                            id="ssn-last-four-alert"
                            type="red"
                            displayType="inline"
                            persistent
                          >
                            An error has occurred. Please try again.
                          </Alert>
                        </div>
                      )}
                      {!isValid ? (
                        <div className="jg-space-mvms">
                          <Button
                            qaClassName="qa-confirm-identity-button"
                            isDisabled
                          >
                            {
                              <FormattedMessage
                                id="PersonalIdNumberForm.confirmSSNInactiveButton"
                                defaultMessage={`Confirm your SSN`}
                              />
                            }
                          </Button>
                        </div>
                      ) : (
                        <LoadingButton
                          loading={isSubmitting}
                          className="jg-btn jg-btn--brand jg-space-mbms"
                          value={
                            <FormattedMessage
                              id="PersonalIdNumberForm.confirmSSNButton"
                              defaultMessage={`Confirm your SSN`}
                            />
                          }
                          analyticsOptions={{
                            event: 'link click',
                            subtype: 'button',
                            eventValue: 'confirm ssn',
                            pageSection: 'admin > verify identity',
                          }}
                        />
                      )}
                      <p className="jg-text--xsmall jg-color--nobel jg-text--center">
                        <FormattedMessage
                          id="PersonalIdNumberForm.disclaimerText"
                          defaultMessage={`JustGiving and the third party that helps us with identity verification will keep your information secure and will only use it for the purposes of verifying your identity`}
                        />
                      </p>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </AnalyticsPageView>
    );
  }
}

export default PersonalIdNumberForm;



// WEBPACK FOOTER //
// ./src/components/AdditionalDetails/PersonalIdNumberForm.tsx